import React from "react";
import FaqSection from "components/FaqSection";

function FaqPage(props) {
  return (
    <FaqSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Kaip naudotis TryMyCar?"
      subtitle="Pabandėme paprastai paaiškinti tai, kas detaliai aprašyta paslaugų teikimo taisyklėse. Bet jeigu vis dar turite klausimų, visada galite kreiptis nurodytais kontaktais arba susisiekite su mumis per Facebook."
    />
  );
}

export default FaqPage;
